import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useGlobalState } from "../../contexts/GlobalContext";
import { fetchUpdateUserMeataData, fetchUserInfoProxy, fetchSessionProxy } from "../../utils/helpers/api";
import { fetchGetAuthorize, fetchGetNewToken, fetchGetNewTokenSpa } from "../../utils/helpers/auth0";
import { Http } from "../../utils/constants";
import { authHelper } from "../../utils/helpers";


const ConfirmSuccess: React.FC = () => {
  const { globalState, setGlobalState, refreshAccessToken } = useGlobalState();
  const [redirectUrl, setRedirectUrl] = useState<string>("");
  const [urlDisplay, setUrlDisplay] = useState<string>("");
  const [isReadyToRedirect, setIsReadyToRedirect] = useState<boolean>(false);
  const [isUpdated, setIsUpdated] = useState<boolean>(false);
  const { user } = globalState;
  const user_id = user?.user_id;

  useEffect(() => {
    const fetchData = async () => {
      let url = localStorage.getItem("returnadvertimes") || "https://www.advertimes.com";
      const external = localStorage.getItem("external");
      setUrlDisplay(url);

      try {
        const refresh_token = authHelper.valueCookie("_rftk");
        const response = await fetchGetNewToken(refresh_token);
        const { access_token, expires_in, refresh_token: new_refresh_token } = response;

        const result1 = await fetchSessionProxy({
          access_token,
          expires_in,
          refresh_token,
          external: true,
        });

        const sessionId = result1?.data?.session_id;

        if (sessionId) {
          const urlObj = new URL(url);
          urlObj.searchParams.set("session_id", sessionId);
          url = urlObj.toString();
        }

        setRedirectUrl(url);
        setIsReadyToRedirect(true);
        updateUserStatus(); 
      } catch (err) {
        console.error("Error in fetchData:", err);
        setRedirectUrl(url); 
        setIsReadyToRedirect(true);
        updateUserStatus();
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (isUpdated && isReadyToRedirect) {
      const timer = setTimeout(() => {
        localStorage.removeItem("returnadvertimes");
        localStorage.removeItem("external");
        window.location.href = redirectUrl;
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isUpdated, isReadyToRedirect, redirectUrl]);

  const handleManualRedirect = () => {
    if (!isReadyToRedirect) return;
    localStorage.removeItem("returnadvertimes");
    localStorage.removeItem("external");
    window.location.href = redirectUrl;
  };

  const updateUserStatus = async () => {
    try {
      const userMetadata = user?.user_metadata ?? {};
      if (userMetadata.user_status === 4) {
        const result = await fetchUpdateUserMeataData(user_id ?? "", {
          ...userMetadata,
          user_status: 5,
          authenticated: 1,
        });
        await refreshAccessToken();
        if (result?.status === Http.SUCCESS_CODE) {
          setGlobalState({
            ...globalState,
            user: {
              ...globalState.user,
              user_metadata: {
                ...userMetadata,
                user_status: 5,
                authenticated: 1,
              },
            },
          });
        }
      }

      setIsUpdated(true);
    } catch (error) {
      console.error("updateUserStatus error:", error);
      setIsUpdated(true);
    }
  };

  return (
    <Box className="login_error center">
      <h5 className="mb32 title h-error">メール認証に成功しました。</h5>
      <h6 className="p-error">{urlDisplay}へ自動遷移します</h6>
      <h6 className="p-error">
        (画面が切り替わらない場合は
        <span
          style={{ color: "#009999", cursor: "pointer" }}
          onClick={handleManualRedirect}
        >
          こちらをクリックしてください
        </span>
        )
      </h6>
    </Box>
  );
};

export default ConfirmSuccess;
